import { useState } from 'react';
import _, { isEmpty } from 'lodash';
import { withTranslation } from 'react-i18next';
import { Input, Label } from 'reactstrap';

import Search from '../Search';
import useQsParams from '../../Hooks/QueryString';

function CheckboxFilter({ item, values, t }) {
  const { qs, setSearchParams } = useQsParams();
  let ARRAY_ITEMS = values.filter((v) => v.value);

  if (item?.values?.length) {
    ARRAY_ITEMS = item?.values.filter((preset) =>
      [...ARRAY_ITEMS].find((dynamic) => dynamic.value === preset?.value)
    );
  }

  const [searchTerm, setSearchTerm] = useState('');

  const updateCheckboxValue = (_key, value) => {
    const newParams = new URLSearchParams(window.location.search);
    const currentValues = newParams.get(_key)?.split(',') || [];
    const existing = _.uniq([...currentValues]);

    if (existing.indexOf(value) !== -1) {
      existing.splice(existing.indexOf(value), 1);
    } else {
      existing.push(value);
    }

    if (existing.length > 0) {
      newParams.set(_key, existing.join(','));
    } else {
      newParams.delete(_key);
    }
    newParams.set('page', '1');

    window.history.pushState({}, '', `?${newParams.toString()}`);
    window.dispatchEvent(new Event('popstate'));
  };

  const filteredItems = searchTerm
    ? ARRAY_ITEMS.filter((item) =>
        item?.label
          ?.toString()
          .toLowerCase()
          ?.includes(searchTerm.toLowerCase())
      )
    : ARRAY_ITEMS;

  return (
    <div className="mb-4 filter-item">
      <Label className="form-label text-muted text-uppercase fw-semibold mb-3 d-flex justify-content-between">
        <span>{item.name}</span>

        {qs.get(item.field)?.length && filteredItems?.length ? (
          <span
            className="fw-normal"
            onClick={() => {
              const newParams = new URLSearchParams(window.location.search);
              newParams.delete(item.field);
              newParams.set('page', '1');
              window.history.pushState({}, '', `?${newParams.toString()}`);
              window.dispatchEvent(new Event('popstate'));
            }}
            style={{
              cursor: 'pointer',
              textDecoration: 'underline',
              fontSize: 11,
            }}
          >
            {t('clear')}
          </span>
        ) : null}
      </Label>

      {values?.length >= 10 ? (
        <div className="mb-2">
          <Search
            placeholder={`Filtrar ${ARRAY_ITEMS?.length} itens`}
            onSubmit={({ id }) => setSearchTerm(id)}
            onChange={(value) => setSearchTerm(value)}
            value={searchTerm}
          />
        </div>
      ) : null}

      <div
        className="px-1"
        style={{
          maxHeight: 150,
          borderRadius: 4,
          border: '1px solid #ced4da',
          overflowY: 'scroll',
          overflowX: 'auto',
        }}
      >
        {filteredItems.map((value, index) => {
          const i18nPattern = `filters-values.${value.label}`;
          const i18nParsed = t(i18nPattern);
          const hasI18n = i18nParsed !== i18nPattern;

          const selectedValues = qs.get(item.field)?.split(',') || [];

          return (
            <div className="form-check my-1" key={index}>
              <Input
                type="checkbox"
                className="form-check-input"
                value={value.value}
                id={`checkbox-${item.field}-${index}`}
                checked={selectedValues.includes(String(value.value))}
                onChange={(e) => {
                  updateCheckboxValue(item.field, e.target.value);
                }}
              />

              <Label
                className="form-check-label"
                htmlFor={`checkbox-${item.field}-${index}`}
              >
                {hasI18n ? i18nParsed : value.label}
              </Label>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default withTranslation()(CheckboxFilter);
